export const SET_SCROLL_TIMEOUT_ID = 'SET_SCROLL_TIMEOUT_ID';
export const CLEAR_SCROLL_TIMEOUT_ID = 'CLEAR_SCROLL_TIMEOUT_ID';
